<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li><router-link to="/enqueryList">Leads</router-link></li>

          <li class="active"><a href="#">Enquery</a></li>
        </ol>
        <div class="panel-body locationform">
          <div v-if="message" class="alert-danger alert visibility" role="alert">
            {{ message }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <form @submit.prevent="submitForm">
            <div class="row">
                  <legend>Add Enquiry:</legend>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>First Name *</label>
                      <input
                        v-model="enquery.FirstName"
                        v-validate="'required'"
                        type="text"
                        placeholder="First Name"
                        class="form-control"
                        name="firstName"
                      />
                      <span v-if="errors.has('firstName')">
                        {{ errors.first('firstName') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Middle Name</label>
                      <input
                        v-model="enquery.MiddleName"
                        type="text"
                        class="form-control"
                        placeholder="Middle Name"
                        name="MiddleName"
                      />
                      
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Last Name *</label>
                      <input
                        v-model="enquery.LastName"
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        placeholder="Last Name"
                        name="LastName"
                      />
                      <span v-if="errors.has('LastName')">
                        {{ errors.first('LastName') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Mobile Number*</label>
                      <input
                        v-model="enquery.MobileNumber"
                        v-validate="'required|phone'"
                        type="text"
                        class="form-control"
                        placeholder="Mobile Number"
                        name="MobileNumber"
                      />
                      <span v-if="errors.has('MobileNumber')">
                        {{ errors.first('MobileNumber') }}
                      </span>
                    </div>
                  </div>
            </div>
            <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label> Model *</label>
                      <ModelSelectEnquery @selectedOptionArray="selectedOptionArrayFunction"></ModelSelectEnquery>
                    <span v-if="errors.has('ModelNumber')">
                        {{ errors.first('ModelNumber') }}
                    </span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label> Model Name </label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Model name"
                        v-model="enquery.modelName"
                        v-bind:readonly="isReadOnly"
                      />
                    </div>
                  </div>
                    <div class="col-md-2">
                    <div class="form-group">
                      <label> Quantity </label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Quantity"
                        v-model="enquery.Quantity"
                        min="1"
                        step="1"
                      />
                    </div>
                  </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                 <div class="form-group">
                <label>Comments</label>
                <textarea placeholder="Any Comments In Mind" class="form-control" :multiline="true" v-model="enquery.Comments"></textarea>
                 </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-sm-offset-9">
                        <div class="form-group">
                          <button
                            class="btn-raised btn-primary btn fixcolorAs"
                            :disabled="loading"
                          >
                            <span
                              v-show="loading"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <span>Submit</span>
                          </button>
                        </div>
                  </div>
            </div>           
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import chield from './components/child';
import UserService from '../services/user.service';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import ModelSelectEnquery from './components/ModelSelectEnquery'
import VeeValidate from 'vee-validate';
const phoneRule = {
  getMessage(field, args) {
    return `The ${field} must be either a valid phone number`;
  },
  validate(value, args) {
    
    const MOBILEREG = /^(0|[+91]{3})?[7-9][0-9]{9}$/;
    
    // Check for either of these to return true
    return MOBILEREG.test(value);
  }
};

// Extend VeeValidate with our new custom rule
VeeValidate.Validator.extend('phone', phoneRule);

function initialState() {
  return {
        FirstName: '',
        MiddleName: '',
        LastName: '',
        MobileNumber:'',
        modelName:'',
        Quantity:'0',
        Comments:''
      }
}
export default {
  name: 'Enquery',
  data() {
    return {
      loading:false,
      isReadOnly:true,
      message: '',
      SuccessMessage:'',
      enquery: initialState(),
    };
  },
  components: { vSelect,ModelSelectEnquery},
  computed: {
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
    selectedOptionArrayFunction(val){
      this.enquery.modelName =""
      this.enquery.Quantity="00"
      if(typeof(val) !== 'undefined' && val !== null ){
        this.errors.remove('ModelNumber');
        this.enquery.modelName = val.ModelName
        this.enquery.Quantity = val.Quantity
      }
      if (this.enquery.modelName == '') {
          this.errors.add({
            field: 'ModelNumber',
            msg: 'Please Select Model Number',
          });
        }
    },

    submitForm() {
      this.$validator.validateAll().then((res) => {
         if (this.enquery.modelName == '') {
          this.errors.add({
            field: 'ModelNumber',
            msg: 'Please Select Model Number',
          });
          res = false;
        }
        if (!res) {
          // handle input errors.
          this.message = 'Please Fill all menditory Options';
            setTimeout(() => (this.message = false), 5000);
          return;
        }
        if (res) {
          UserService.postMetod(
            'bajajAPI/Enquery/add',
            this.enquery
          ).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              setTimeout(() => (this.SuccessMessage = false), 5000);
              this.loading = false;
              // on success reset values
              if (response.data.status) {
                this.resetWindow();
                /*Clear Validation */
                 this.$nextTick(() => {
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                });
              }
            },
            (error) => {
              this.loading = false;

              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        } else {
          this.message = 'Please correct all error!';
        }
      });
    },
    resetWindow: function () {
      Object.assign(this.$data.enquery, initialState());
    },
  } 
};
</script>
<style>
.visibility {
  visibility:visible !important;
}

</style>